<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="{fontIcon: 'fa-sign-in', fontSet: 'fad'}"
	[headerText]="T.GLOBAL_TEXT_LOGIN_HEADER | translate"
	[matDialogData]="data"
	[showClosingX]="!dialogRef?.disableClose"
	[rect]="rect"
>
	<ng-container dialogContent>
		<div class="loginWrapper">
			<form [formGroup]="loginFormGroup">
				<mat-form-field color="accent" class="full-width-form">
					<mat-label>{{ T.LOGIN_PAGE_LABEL_USERNAME_OR_PASSWORD | translate }}</mat-label>
					<input
						(keyup.enter)="login()"
						[formControl]="loginFormGroup.controls.username"
						matInput
						placeholder="Username or Email"
					/>
					@if (loginFormGroup.controls.username.invalid) {
						<mat-error>{{ getUsernameErrorMessage() }}</mat-error>
					}
				</mat-form-field>

				<mat-form-field class="full-width-form" color="accent">
					<mat-label>{{ T.LOGIN_PAGE_LABEL_ENTER_PASSWORD | translate }}</mat-label>
					<input
						(keyup.enter)="login()"
						[formControl]="loginFormGroup.controls.password"
						[type]="hidePassword ? 'password' : 'text'"
						matInput
						required
					/>
					<button
						(click)="hidePassword = !hidePassword"
						[attr.aria-label]="'Hide password'"
						[attr.aria-pressed]="hidePassword"
						mat-icon-button
						matSuffix
					>
						@if (hidePassword) {
							<mat-icon fontSet="fas" fontIcon="fa-eye-slash" style="font-size: 0.8em" inline />
						}
						@if (!hidePassword) {
							<mat-icon fontSet="far" fontIcon="fa-eye" style="font-size: 0.8em" inline />
						}
					</button>
					@if (loginFormGroup.controls.password.invalid) {
						<mat-error>{{ getPasswordErrorMessage() }}</mat-error>
					}
				</mat-form-field>
			</form>
		</div>
	</ng-container>

	<ng-container actions>
		<sim-button (onClick)="close()" [icon]="{fontSet: 'fal', fontIcon: 'fa-times'}" [label]="T.BUTTON_CLOSE" color="warn" />
		<sim-button
			[appBusy]="loggingIn"
			[disabled]="loginFormGroup.invalid || loggingIn"
			(onClick)="login()"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.GLOBAL_TEXT_LOGIN_HEADER"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
